import { render, staticRenderFns } from "./StatisticsProduct.vue?vue&type=template&id=ad776382&"
import script from "./StatisticsProduct.vue?vue&type=script&lang=js&"
export * from "./StatisticsProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports